/* eslint-disable quote-props */
import {
  backgroundCover,
  wrapperStyles,
  columnsWrapperStyles,
  singleColumnStyles,
  singleColumnTabletStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  dividerStyles,
  typoHeader,
  typoHeaderMobile,
  typoParagraph,
  socialMediaIconStyles,
} from 'components/Templates/styles/Red/commonObjectsStyles';

import wwwIcon from 'components/Templates/globalAssets/icons/icons_website.svg?url';
import facebookIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_facebook.svg?url';
import linkedinIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_linkedin.svg?url';
import twitterIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_twitter.svg?url';
import instagramIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_instagram.svg?url';


export default
{
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color': '{backgroundColor}',
      'display': 'block'
    },
    '76_8': {
      ...sectionWrapperTabletStyles
    },
    '37_5': {
      ...sectionWrapperMobileStyles,
      'padding-bottom': '1rem'
    }
  },
  divider: {
    '0': {
      ...dividerStyles
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles,
    },
    '76_8': {
      ...wrapperWithMarginTabletStyles
    }
  },
  columnsWrapper: {
    '0': {
      ...columnsWrapperStyles,
      'width': '100%',
      'margin-bottom': '2rem',
      'min-height': '45rem'
    }
  },
  columnDescription: {
    '0': {
      ...singleColumnStyles,
      'padding-right': '5rem'
    },
    '76_8': {
      ...singleColumnTabletStyles,
      'padding-right': '0'
    }
  },
  columnImage: {
    '0': {
      ...singleColumnStyles,
      ...backgroundCover,
      'position': 'absolute',
      'height': '100%',
      'aspect-ratio': '1'
    },
    '76_8': {
      ...singleColumnTabletStyles,
      'position': 'relative',
      'aspect-ratio': '2'
    },
    '37_5': {
      'aspect-ratio': '1'
    }
  },
  title: {
    '0': {
      ...typoHeader,
    },
    '76_8': {
      ...typoHeaderMobile,
    },
  },
  description: {
    '0': {
      ...typoParagraph,
      'margin-bottom': '6rem'
    },
    '76_8': {
      'margin-bottom': '3rem'
    }
  },
  address: {
    '0': {
      ...typoParagraph,
    }
  },
  zip: {
    '0': {
      ...typoParagraph,
      'margin-right': '0.5rem'
    }
  },
  city: {
    '0': {
      ...typoParagraph,
    }
  },
  country: {
    '0': {
      ...typoParagraph,
    }
  },
  venueIcons: {
    '0': {
      'margin-top': '6rem',
      'width': '100%',
      'overflow': 'hidden'
    },
    '76_8': {
      'margin-bottom': '5rem'
    }
  },
  venueFacebookIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '1.5rem',
      'background-image': `url(${facebookIcon})`,
    },
    '37_5': {
      'margin-right': '0.6rem',
    }
  },
  venueLinkedinIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '1.5rem',
      'background-image': `url(${linkedinIcon})`,
    },
    '37_5': {
      'margin-right': '0.6rem',
    }
  },
  venueTwitterIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '1.5rem',
      'background-image': `url(${twitterIcon})`,
    },
    '37_5': {
      'margin-right': '0.6rem',
    }
  },
  venueInstagramIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '1.5rem',
      'background-image': `url(${instagramIcon})`,
    },
    '37_5': {
      'margin-right': '0.6rem',
    }
  },
  venueWebIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'background-image': `url(${wwwIcon})`,
    },
    '37_5': {
      'margin-right': '0.6rem',
    }
  },
  map: {
    '0': {
      'width': '100%',
      'margin-bottom': '5rem',
      'height': '50rem'
    }
  }
};
